export default __webpack_public_path__ + "svg/calendar/2027/0/marzo.svg?3683ffa6";